import { DeleteOutlined, DownOutlined } from "@ant-design/icons";
import { App, Dropdown, Modal } from "antd";
import { observer } from "mobx-react";
import { useCallback, useState } from "react";
import { AccountAddLicenseForm } from ".";
import { RealCommerceError } from "../../../../exceptions";
import { useRealCommerceErrorHandling } from "../../../../hooks";
import { providedModal } from "../../../../others";
import { IMPREZA_BUTTON_PROPS, __ } from "../../../../utils";
const AccountLicenseActions = observer(_ref => {
  let {
    record
  } = _ref;
  const {
    modal: antdModal
  } = App.useApp();
  const {
    data: {
      id
    },
    subscription
  } = record;
  const {
    canBeModified
  } = subscription;
  const handleRealCommerceError = useRealCommerceErrorHandling();
  const [isEditLicenseVisible, setIsEditLicenseVisible] = useState(false);
  const handleDeleteClick = useCallback(async () => {
    const modal = providedModal("confirm", __("Note that after deletion, all active activations of this license will no longer be working."), antdModal, {
      title: __("Are you sure to delete this license?"),
      icon: /*#__PURE__*/React.createElement(DeleteOutlined, null),
      okButtonProps: {
        ...IMPREZA_BUTTON_PROPS,
        onClick: async e => {
          e.preventDefault();
          modal.update({
            okButtonProps: {
              ...IMPREZA_BUTTON_PROPS,
              loading: true
            }
          });
          try {
            await record.delete();
            modal.destroy();
          } catch (e) {
            if (e instanceof RealCommerceError) {
              handleRealCommerceError(e);
            }
          }
        }
      },
      okText: __("Delete")
    });
  }, [record]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    open: isEditLicenseVisible,
    title: __("Edit license"),
    okText: __("Save"),
    cancelText: __("Cancel"),
    onCancel: () => setIsEditLicenseVisible(false),
    okButtonProps: {
      form: `edit-license-form-${id}`,
      htmlType: "submit",
      ...IMPREZA_BUTTON_PROPS
    }
  }, /*#__PURE__*/React.createElement(AccountAddLicenseForm, {
    record: subscription,
    edit: record,
    onSave: () => setIsEditLicenseVisible(false)
  })), /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: [{
        key: "edit",
        disabled: !canBeModified,
        onClick: () => setIsEditLicenseVisible(true),
        label: __("Edit")
      }, {
        key: "add",
        danger: canBeModified,
        disabled: !canBeModified,
        onClick: handleDeleteClick,
        label: __("Delete")
      }]
    },
    placement: "bottomRight",
    trigger: ["click"]
  }, /*#__PURE__*/React.createElement("a", null, __("Actions"), " ", /*#__PURE__*/React.createElement(DownOutlined, null))));
});
export { AccountLicenseActions };